// V8 시딩 시 "어느 CDN 파일을 어느 seed key 로 넣느냐" 해석.
//
// seedByKey 의 **키는 바뀌지 않는다**(serverLeagueRewards / serverLeagueSeasons).
// verse 마다 $global 저장소가 독립이므로, flavor 별로 다른 건 읽어올 파일뿐이다.
// 덕분에 services/server 는 무변경이다.
// 설계: docs/superpowers/specs/2026-08-09-league-reward-web2-web3-split-design.md
import type { VerseFlavor } from '../admin-verses';

const FLAVOR_SUFFIX: Record<VerseFlavor, string> = { web2: 'Web2', web3: 'Web3' };

/** flavor 별 파일로 발행되는 시드 키. */
const FLAVORED_SEED_KEYS: ReadonlySet<string> = new Set([
  'serverLeagueRewards',
  'serverLeagueSeasons',
]);

/**
 * 서버 gameConfig 컬렉션은 server-manifest 의 serverGameConfig 파일(degenConfig 전체)
 * 에서 시딩한다. 과거엔 clientGameConfig 를 썼으나, 클라용이 슬림화되면서 서버 전용
 * full 파일로 분리됐다.
 */
const STATIC_FILENAME: Record<string, string> = { gameConfig: 'serverGameConfig' };

/** 이 키는 verse flavor 마다 다른 파일에서 시딩해야 한다. */
export function isFlavoredSeedKey(seedKey: string): boolean {
  return FLAVORED_SEED_KEYS.has(seedKey);
}

export function resolveSeedCdnFilename(seedKey: string, flavor: VerseFlavor): string {
  if (FLAVORED_SEED_KEYS.has(seedKey)) return `${seedKey}${FLAVOR_SUFFIX[flavor]}`;
  return STATIC_FILENAME[seedKey] ?? seedKey;
}
